import React from "react";
import MaterialTableRtl from "../../UI/MaterialTableRtl/MaterialTableRtl";
import { client } from "../../../service/ApolloClient/ApolloClient";
import { QUERY_CHEQUES } from "../../../service/ApolloClient/ApolloQueries";
import { Box, Chip, Tooltip } from "@material-ui/core";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import { MUTATION_REMOVE_CHEQUE } from "../../../service/ApolloClient/ApolloMutation";
import { SuccessToast } from "../../../hoc/ToastNotify/ToastNotify";
import { typeChequeName } from "../../../containers/Cheque/ChequeListPage";
import { withRouter } from "react-router";
import { confirmAlert } from "react-confirm-alert"; // Import
import { Alert } from "@material-ui/lab";
import "react-confirm-alert/src/react-confirm-alert.css";
import ChequeAdvancedSearch from "../../../containers/Cheque/AdvancedSearch/ChequeAdvancedSearch";
import {numberFormatter} from "../../../utility/Number/numberFormatter"; // Import css

class ChequeList extends React.Component {
  tableRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      data: [],
      search: {},
      columns: [
        {
          title: "#",
          field: "id",
          render: (rowData) => {
            return (
              <Link to={`/cheque/edit/${rowData.id}`}>
                {rowData.guarantor_id === 79 ? (
                  <Tooltip title={"ضمانت فریدونی"}>
                    <Chip
                      color={"secondary"}
                      variant="outlined"
                      label={rowData.id}
                    />
                  </Tooltip>
                ) : (
                  rowData.id
                )}
              </Link>
            );
          },
        },
        {
          title: "مبلغ",
          field: "amount",
          render: (rowData) => (
            <NumberFormat
              value={rowData.amount}
              thousandSeparator={true}
              displayType={"text"}
            />
          ),
          pdfRender: (rowData) => numberFormatter(rowData.amount)
        },
        {
          title: "سررسید",
          field: "due_date_fa",
          render: (rowData) => rowData.due_date_fa,
        },

        { title: "شماره چک", field: "cheque_id" },

        { title: "شماره صیاد", field: "icis" },

        {
          title: "دهنده",
          field: "giver_user_fullname",
          render: (rowData) =>
            rowData.giver_user_id ? (
              <a href={`/person/edit/${rowData.giver_user_id}`}>
                {rowData.giver_user_fullname}
              </a>
            ) : (
              "مشخص نشده"
            ),
        },
        {
          title: "گیرنده",
          field: "reciver_user_fullname",
          render: (rowData) => {
            const name = rowData.reciver_user_fullname;
            if (!name) return "مشخص نشده";
            const type = rowData.recieverable_type;
            const id = rowData.recieverable_id;
            if (type === "bank") {
              return <a href={`/bank-account/edit/${id}`}>{name}</a>;
            }
            if (type === "legal_entity") {
              return <a href={`/legal-entity/edit/${id}`}>{name}</a>;
            }
            return <a href={`/person/edit/${rowData.reciver_user_id}`}>{name}</a>;
          },
        },
        {
          title: "مالک",
          field: "first_party_fullname",
          render: (rowData) =>
            rowData.first_party_id ? (
              <a href={`/person/edit/${rowData.first_party_id}`}>
                {rowData.first_party_fullname}
              </a>
            ) : (
              "مشخص نشده"
            ),
        },
        {
          title: "در وجه",
          field: "second_party_fullname",
          render: (rowData) =>
            rowData.second_party_id ? (
              <a href={`/person/edit/${rowData.second_party_id}`}>
                {rowData.second_party_fullname}
              </a>
            ) : (
              "مشخص نشده"
            ),
        },

        {
          title: "وضعیت",
          field: "status",
          sorting: false,
          render: (rowData) => {
            return rowData.status === "cashed" ? (
              <Box style={{ textAlign: "center" }}>
                <Box>
                  <Alert severity={"success"}>پاس شده</Alert>
                </Box>
                <Box>{rowData.cashed_date_fa}</Box>
              </Box>
            ) : rowData.status === "bounced" ? (
              <Box style={{ textAlign: "center" }}>
                <Box>
                  <Alert severity={"error"}>برگشت خورده</Alert>
                </Box>
                <Box>{rowData.bounced_date_fa}</Box>
              </Box>
            ) : rowData.status === "returned-settlement" ? (
              <Box style={{ textAlign: "center" }}>
                <Box>
                  <Alert severity={"warning"}>عودتی - تسویه</Alert>
                </Box>
                <Box>{rowData.returned_date_fa}</Box>
              </Box>
            ) : rowData.status === "returned-unresolved" ? (
              <Box style={{ textAlign: "center" }}>
                <Box>
                  <Alert severity={"warning"}>عودتی - بلاتکلیف</Alert>
                </Box>
                <Box>{rowData.returned_date_fa}</Box>
              </Box>
            ) : (
              <Box style={{ textAlign: "center" }}>-</Box>
            );
          },
          pdfRender: (rowData) => {
            if (rowData.status === "cashed") {
              return `${rowData.cashed_date_fa} - پاس شده`;
            } else if (rowData.status === "bounced") {
              return `${rowData.bounced_date_fa} - برگشت خورده`;
            } else if (rowData.status === "returned-settlement") {
              return `${rowData.returned_date_fa ? rowData.returned_date_fa : ''} - عودت تسویه`;
            } else if (rowData.status === "returned-unresolved") {
              return `${rowData.returned_date_fa ? rowData.returned_date_fa : ''} - عودت مفتوح`;
            } else {
              return "-";
            }
          },
        },
      ],
    };

    this.remoteData = this.remoteData.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.updateSearch = this.updateSearch.bind(this);
  }

  componentDidMount() {
    // this.fetchData();
  }

  remoteData = (query) => {
    // console.log(this.state.search)
    return client
      .query({
        query: QUERY_CHEQUES,
        variables: {
          page: query.page + 1,
          limit: query.pageSize,
          search: query.search,
          orderBy: query.orderBy ? query.orderBy.field : null,
          orderDirection: query.orderDirection,
          type: this.props.type,
          user: parseInt(this.props.user),
          cheque_id: this.props.cheque_id,
          car_contract_id: this.props.car_contract_id,
          ...this.state.search,
        },
        fetchPolicy: "network-only",
      })
      .then((res) => {
        let data = structuredClone(res.data);

        return {
          data: data.cheques.data,
          page: query.page,
          totalCount: data.cheques.total,
        };
      });
  };

  updateSearch(fields) {
    this.setState({
      search: fields,
    });
    this.tableRef.current.onQueryChange();
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (this.props.type !== nextProps.type) {
      this.tableRef.current.onQueryChange();
      return true;
    }
    return false;
  }

  handleRemove = (id) => {
    confirmAlert({
      title: "تاییدیه حذف",
      message: "آیا واقعا می خواهید حذف کنید.",
      buttons: [
        {
          label: "بله",
          onClick: () => {
            client
              .mutate({
                mutation: MUTATION_REMOVE_CHEQUE,
                variables: {
                  id: id,
                },
              })
              .then((res) => {
                let d = res.data.removeCheque;
                this.tableRef.current.onQueryChange();
                SuccessToast("با موفقیت حذف گردید");
              })
              .catch((err) => console.log(err));
          },
        },
        {
          label: "بی خیال",
          onClick: () => {},
        },
      ],
    });
  };

  render() {
    const { columns, data, actions } = this.state;
    let title = "چک ها" + (this.props.name ? this.props.name : "") + typeChequeName(this.props.type)

    return (
      <div>
        {this.props.isAdvanced ? (
          <Box mb={2}>
            <ChequeAdvancedSearch updateSearch={this.updateSearch} />
          </Box>
        ) : null}
        <MaterialTableRtl
          tableRef={this.tableRef}
          det
          columns={columns}
          data={this.remoteData}
          handleRemove={(id) => {
            this.handleRemove(id);
          }}
          editLink={"/cheque/edit/"}
          perPage={this.props.perPage}
          needExport={true}
          pdfName={this.props.pdfName? this.props.pdfName : title}
          title={title}
        />
      </div>
    );
  }
}

export default withRouter(ChequeList);
